import { z } from "zod";
import {
  githubProjectRepositorySchema,
  githubProjectSchema,
  projectSchema
} from "../project/index.js";
import { themeSchema } from "../theme/index.js";
import { nanoidSchema } from "../utility/index.js";
const headingRecordSchema = z.object({
  slug: z.string(),
  name: z.string(),
  level: z.coerce.number().int(),
  uid: nanoidSchema,
  parent: z.string().optional()
}).meta({ id: "heading-record" });
const publishAssetSchema = z.object({
  path: z.string(),
  data: z.string()
}).meta({ id: "publish-asset" });
const typesenseConfigSchema = z.object({
  keyId: z.number(),
  keyValue: z.string(),
  collectionName: z.string()
}).meta({ id: "typesense-config" });
const publishDeployRequestSchema = z.object({
  token: z.string(),
  teamUid: nanoidSchema,
  publishUid: nanoidSchema,
  subdomain: z.string(),
  /** A map of page ids to YJS document ids */
  yjsDocs: z.record(z.string(), z.string()),
  /** A map of reference ids to YJS document ids */
  yjsReferences: z.record(z.string(), z.string()),
  project: projectSchema,
  theme: themeSchema,
  customDomain: z.string().nullable(),
  isPaid: z.boolean().optional(),
  preview: z.boolean().optional(),
  typesenseConfig: typesenseConfigSchema
}).meta({ id: "publish-deploy-request" });
const publishGithubRequestSchema = z.object({
  token: z.string(),
  teamUid: nanoidSchema,
  publishUid: nanoidSchema,
  subdomain: z.string(),
  customDomain: z.string().optional().default(""),
  encryptedGithubToken: z.string(),
  project: githubProjectSchema.extend({
    repository: githubProjectRepositorySchema
  }),
  theme: themeSchema,
  isPaid: z.boolean().default(false),
  preview: z.boolean().optional(),
  branch: z.string(),
  typesenseConfig: typesenseConfigSchema
}).meta({ id: "publish-github-request" });
const sparseConfigSchema = z.object({
  subdomain: z.string(),
  customDomain: z.string(),
  isPrivate: z.boolean(),
  accessGroups: nanoidSchema.array(),
  loginPortal: z.string(),
  publishOnMerge: z.boolean(),
  publishPreviews: z.boolean(),
  prComments: z.boolean(),
  subpath: z.string().optional()
}).partial().meta({ id: "sparse-config" });
const publishCliRequestSchema = z.object({
  token: z.string(),
  teamUid: nanoidSchema,
  publishUid: nanoidSchema,
  subdomain: z.string(),
  customDomain: z.string().optional().default(""),
  assets: publishAssetSchema.array(),
  documents: z.record(z.string(), z.string()),
  references: z.record(z.string(), z.string()),
  project: projectSchema,
  theme: themeSchema,
  isPaid: z.boolean().default(false),
  gitProjectUid: nanoidSchema,
  preview: z.boolean().optional(),
  sparseConfig: sparseConfigSchema,
  typesenseConfig: typesenseConfigSchema
}).meta({ id: "publish-cli-request" });
const staticDocSchema = z.object({
  html: z.string(),
  headings: z.record(z.string(), headingRecordSchema),
  markdown: z.string()
}).meta({ id: "static-doc" });
const staticContentSchema = z.record(z.string(), staticDocSchema).meta({ id: "static-content" });
const sparsePublishDataSchema = z.object({
  project: projectSchema,
  theme: themeSchema,
  isPaid: z.boolean().default(false),
  typesenseKey: z.string(),
  typesenseHost: z.string(),
  typesenseCollection: z.string(),
  proxy: z.url()
}).meta({ id: "sparse-publish-data" });
const cliPublishResponseSchema = z.object({
  publishUid: z.string(),
  typesenseConfig: typesenseConfigSchema
}).meta({ id: "cli-publish-response" });
const splitOutputDataSchema = z.object({
  staticDocs: staticContentSchema,
  errors: z.string().array()
}).meta({ id: "split-output-data" });
const PUBLISH_REQUEST_TIMEOUT = 6e5;
const PUBLISH_REQUEST_TIMEOUT_SECONDS = 600;
export {
  PUBLISH_REQUEST_TIMEOUT,
  PUBLISH_REQUEST_TIMEOUT_SECONDS,
  cliPublishResponseSchema,
  headingRecordSchema,
  publishAssetSchema,
  publishCliRequestSchema,
  publishDeployRequestSchema,
  publishGithubRequestSchema,
  sparseConfigSchema,
  sparsePublishDataSchema,
  splitOutputDataSchema,
  staticContentSchema,
  staticDocSchema,
  typesenseConfigSchema
};
//# sourceMappingURL=publish.js.map
